import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Paper, Typography } from '@material-ui/core';
import useStyles from './styles';

import ProductGroupsTable from '../Components/ProductGroupsTable';
import Button from '../../../components/Button';

const ProductGroupsListView = () => {
  const styles = useStyles();
  const { t } = useTranslation();
  const history = useHistory();
  const createUrl = '/product-groups/create';
  return (
    <>
      <div className={styles.content}>
        <div className={styles.header}>
          <Typography variant='h4' className={styles.title}>{t('productGroup.title')}</Typography>
          <Button
            id="save-btn"
            variant="outlined"
            className={styles.createButton}
            text={t('productGroup.create')}
            height="40px"
            width="220px"
            backgroundColor='theme-custom-solidButtonBackground'
            color='theme-custom-solidButtonText'
            borderRadius='10px'
            onClick={() => history.push(createUrl)}
          />
        </div >
        <Paper>
          <ProductGroupsTable />
        </Paper>
      </div>
    </>
  );
};

export default ProductGroupsListView;
